module.exports = __webpack_public_path__ + "icon_person_hearing_100green.b1a4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_person_hearing_100green.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_person_hearing_100green.svg
// module chunks = main